<template>
	<div
		ref="dropdownRef"
		class="kk-select-dropdown"
		:class="[
			isAutoWidth ? 'kk-select-dropdown--auto-width' : '',
		]"
	>
		<div
			v-show="showBottomOverlay"
			class="kk-select-dropdown__overlay kk-select-dropdown__overlay--bottom"
		></div>

		<div
			v-show="showTopOverlay"
			class="kk-select-dropdown__overlay kk-select-dropdown__overlay--top"
		></div>

		<div
			ref="dropdownContentRef"
			class="kk-select-dropdown__content"
			@scroll="handleScroll"
		>
			<slot></slot>
		</div>
	</div>
</template>

<script>
import {
	onBeforeUnmount,
	onMounted,
	ref,
	unref,
} from 'vue';

export default {
	name: 'KkDropdown',
	props: {
		isAutoWidth: {
			type: Boolean,
			default: true,
		},
	},
	setup() {
		const dropdownRef = ref(null);
		const dropdownContentRef = ref(null);
		const showTopOverlay = ref(false);
		const showBottomOverlay = ref(false);

		function handleScroll() {
			const dropdownContainer = unref(dropdownContentRef);
			const scrollTop = dropdownContainer.scrollTop;
			const maxScroll = dropdownContainer.scrollHeight - dropdownContainer.clientHeight;

			showTopOverlay.value = scrollTop > 0;
			showBottomOverlay.value = scrollTop < maxScroll;
		}

		function centerElement(el) {
			if (!el) {
				return;
			}
			const dropdownContent = dropdownContentRef.value;
			const optionHeight = el.offsetHeight;
			dropdownContent.scrollTop = el.offsetTop - (dropdownContent.offsetHeight / 2) + (optionHeight / 2);
		}

		onMounted(() => {
			handleScroll();
			dropdownContentRef.value.addEventListener('scroll', handleScroll);
		});

		onBeforeUnmount(() => {
			dropdownContentRef.value.removeEventListener('scroll', handleScroll);
		});

		return {
			dropdownRef,
			dropdownContentRef,
			handleScroll,
			showTopOverlay,
			showBottomOverlay,
			centerElement,
		};
	}
}
</script>
